{
  "pt": {
    "milestone_unit": {
      "actions": {
        "change_milestone": "Modificar marco",
        "reset_columns": "Redefinir colunas"
      },
      "labels": {
        "columns": "Colunas",
        "milestone": "Selecionar uma nova etapa",
        "no_results": "Não foram encontradas unidades"
      }
    }
  }
}